import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  NavbarToggler,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Dropdown,
} from "reactstrap";
import { connect } from "react-redux";
import { logout } from "../../actions/actionLogin";
import { Link } from "react-router-dom";
import allApps from "../../../assets/images/apps.png";
import settings from "../../../assets/images/settings.png";
import notifications from "../../../assets/images/notifications.png";
import help from "../../../assets/images/help.png";
import logoutIcon from "../../../assets/images/logoutIcon.png";
import profile from "../../../assets/images/profile.png";
import { IS_ADMIN, USER_NAME } from "../../constants/Constants";
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-minimized");
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-mobile-show");
  }

  asideToggle(e) {
    e.preventDefault();
    e.target.classList.add("fa-angle-left");
    document.body.classList.toggle("aside-menu-hidden");
  }

  render() {
    let lastPage = "";
    let header_logo = window.localStorage.getItem("header_logo");
    header_logo = header_logo ? header_logo : "img/headerlogo.png";
    let elem = document.getElementById("favicon");
    let favicon_logo = window.localStorage.getItem("favicon_logo");

    if (favicon_logo != undefined) {
      elem.href = favicon_logo;
    }

    let html_title = window.localStorage.getItem("html_title");

    if (html_title != undefined) {
      document.title = html_title;
    }

    const userName = USER_NAME ? USER_NAME.slice(0, 2) : "";
    const pathname =
      this.props.history &&
      this.props.history.location &&
      this.props.history.location.pathname;

    lastPage =
      pathname === "/dashboard"
        ? ""
        : pathname === "/userdashboard"
        ? lastPage
        : pathname;

    return (
      <header className="app-header navbar">
        <div className="flex_block">
          {!(pathname === "/userdashboard" || pathname === "/userprofile") && (
            <NavbarToggler
              className="d-lg-none"
              onClick={this.mobileSidebarToggle}
            >
              <i className="fa fa-bars" aria-hidden="true"></i>
            </NavbarToggler>
          )}
          <Link to={"/"}>
            <img
              className="header_logo"
              src={header_logo}
              height="35"
              alt="logo"
            />
          </Link>
          {IS_ADMIN && (
            <div className="appbox">
              <Link to={"/userdashboard"}>
                <button
                  className={
                    pathname === "/userdashboard" ? "active" : "app-btn"
                  }
                >
                  {" "}
                  <img src={allApps} alt="allApps" />{" "}
                  <span className="icon-description">Workspaces</span>
                </button>
              </Link>
              <Link to={lastPage ? lastPage : "/dashboard"}>
                <button
                  className={
                    IS_ADMIN && !(pathname === "/userdashboard")
                      ? "active"
                      : "app-btn"
                  }
                >
                  {" "}
                  <img src={settings} alt="allApps" />{" "}
                  <span className="icon-description">Admin</span>
                </button>
              </Link>
            </div>
          )}
          {!IS_ADMIN && (
            <Link to={"/userdashboard"}>
              <button
                className={
                  pathname === "/userprofile"
                    ? "enable-appIcon active"
                    : "disable-appIcon"
                }
              >
                <img src={allApps} alt="allApps" />
              </button>
            </Link>
          )}
        </div>
        <div className="navbar-right">
         {/* <button className="notification-btn mr-3">
            {" "}
            <img src={help} alt="help" />
          </button>
          <button className="notification-btn mr-3">
            {" "}
            <img src={notifications} alt="notifications" />
          </button>*/}
          <Dropdown
            isOpen={this.state.isOpen}
            toggle={() => {
              this.setState({
                isOpen: !this.state.isOpen,
              });
            }}
          >
            {userName && (
              <DropdownToggle caret>
                <div className="circle">
                  <span className="initials">
                    {userName.charAt(0).toUpperCase() +
                     userName.charAt(1).toLowerCase()}
                  </span>
                </div>

              </DropdownToggle>
            )}
            <DropdownMenu>
              <DropdownItem
                className=""
                onClick={() => {
                  this.props.history && IS_ADMIN
                    ? this.props.history.push("/adminprofile")
                    : this.props.history.push("/userprofile");
                }}
              >
                <div>
                  <img src={profile} alt="profile" />
                  Profile
                </div>
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  this.props.history && this.props.history.push("/logout");
                }}
              >
                <div>
                  <img src={logoutIcon} alt="logout" />
                  Logout
                </div>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </header>
    );
  }
}

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    logout: (logout_data) => {
      dispatch(logout(logout_data));
    },
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));



// WEBPACK FOOTER //
// ./src/components/Header/Header.js